module.exports = __webpack_public_path__ + "img/DW365-234.cb08588a.jpg";